import { Stack } from "@mui/material";
import React from "react";
import { ParagraphText, TabPanel } from "../atoms";
import { DynamicTabContent } from "../molecules";

export const AboutUsTabItem = ({
  index,
  activeTabIndex,
  title,
  data,
  corporateValueItems,
  corporateValueTitle,
}) => {
  return (
    <TabPanel
      tabName="about-us"
      index={index}
      value={activeTabIndex}
      style={{ padding: 0 }}
    >
      <Stack rowGap="36px">
        {/* TAB TITLE */}
        <ParagraphText style={{ fontWeight: 500 }}>{title}</ParagraphText>

        {/* TAB CONTENT */}
        {data
          ?.filter((section) => {
            const sectionTitle = section?.title?.toLowerCase();
            return (
              !sectionTitle?.includes("licensed employee") &&
              !sectionTitle?.includes("corporate structure")
            );
          })
          ?.map((section, index) => (
          <DynamicTabContent
            key={index}
            title={section?.title}
            icon={section?.icon?.data?.attributes?.url}
            description={section?.description}
            images={section?.image?.data}
            dropdownItems={section?.dropdowns}
            cardGridItems={
              section?.__component?.includes("title-and-item-desc")
                ? section?.items || section?.item
                : undefined
            }
            iconParagraphItems={
              section?.__component?.includes("title-and-items")
                ? section?.items || section?.item
                : undefined
            }
            corporateValueTitle={corporateValueTitle}
            corporateValueItems={corporateValueItems}
          />
        ))}
      </Stack>
    </TabPanel>
  );
};
